import { useEffect, useState } from 'react';

import { mediaUp } from '../utils/mediaUp';

/**
 * How many items a carousel shows: 1 on phones, `desktopCount` from the `md` breakpoint up. Starts at 1 on the server
 * and the first client render, then follows the screen width.
 */
export function useItemsPerView(desktopCount: number): number {
    const [itemsPerView, setItemsPerView] = useState(1);

    useEffect(() => {
        const mdQuery = window.matchMedia(mediaUp('md'));
        const update = (): void => setItemsPerView(mdQuery.matches ? desktopCount : 1);

        update();
        mdQuery.addEventListener('change', update);

        return () => mdQuery.removeEventListener('change', update);
    }, [desktopCount]);

    return itemsPerView;
}
